import './styles/global.css';
import './styles/login.css';
import './styles/workspace.css';
import './styles/dialogs.css';

import { Home } from './components/Home';
import { NameStep } from './components/Onboarding';
import { useCurrentUser } from './components/useCurrentUser';
import { LoginPage } from './pages/LoginPage';
import { t } from './i18n';

export function App(): React.ReactNode {
  const { state, refresh } = useCurrentUser();

  if (state.kind === 'loading') {
    return (
      <main className="login">
        <p className="login__subtitle" role="status">
          {t('app.loading')}
        </p>
      </main>
    );
  }

  if (state.kind === 'anonymous') {
    return <LoginPage />;
  }

  // A magic-link sign-in has no name yet. Ask for it once, then continue.
  if (!state.user.name) {
    return <NameStep user={state.user} onSaved={refresh} />;
  }

  return <Home user={state.user} onSignedOut={refresh} />;
}
